class SelectVariantPicker extends HTMLElement {
    constructor() {
        super();
        this.selectButton = this.querySelector('.select-variant__button');
        this.variantPicker = this.querySelector('.variant-picker__container');
        this.ATCbutton = this.closest('.product-form-buttons')?.querySelector('add-to-cart-component');
        this.selectButton?.addEventListener('click', this.handleSelect.bind(this));
    }

    handleSelect = () => {
        this.selectButton?.classList.add('hidden');
        this.variantPicker?.classList.remove('hidden');
        this.ATCbutton?.classList.remove('hidden');
    };
}

if (!customElements.get('select-variant-picker')) {
    customElements.define('select-variant-picker', SelectVariantPicker);
}
